import { useState, useEffect } from 'react';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const services = [
    {
      icon: 'ri-global-line',
      title: '国際貿易・サプライチェーン事業',
      subtitle: '生産管理〜輸出｜20年の経験',
      description: '中国の信頼あるメーカーと連携し、生産管理から国際貿易・輸出対応まで、約20年にわたる実務経験を基盤としたサプライチェーン事業を行っています。',
      details: [
        '生産体制の構築および進行管理',
        '品質基準・納期管理',
        '輸出入業務および国際物流に関する調整'
      ]
    },
    {
      icon: 'ri-store-2-line',
      title: '中国市場向けブランド運営・展開支援',
      subtitle: 'ベビー・キッズ｜ゴルフアパレル',
      description: '中国市場への展開を検討する日本および海外ブランドに対し、ブランド運営および販売展開の支援を行っています。',
      details: [
        'ベビー・キッズ分野の新興ブランド',
        '高付加価値スポーツ分野におけるゴルフ関連アパレル',
        'ブランドポジショニングから販売展開まで'
      ]
    },
    {
      icon: 'ri-chat-smile-2-line',
      title: '日中ビジネス・コンサルティング事業',
      subtitle: '実務視点に基づいた支援',
      description: '日中間での事業展開を検討する企業および事業者向けに、実務視点に基づいたコンサルティングサービスを提供しています。',
      details: [
        '日中市場に関する情報整理・調査',
        '事業方針および展開計画の検討支援',
        'パートナー選定および事業連携支援'
      ]
    }
  ];

  const brands = [
    {
      name: 'Rylee + Cru',
      logo: 'https://brands.mifasia.com/images/p501.jpg',
      description: '現代の子どもと母親のための独特な品味を持つ服飾ブランド。芸術性と想像力を兼ね備えた高品質な製品を提供。'
    },
    {
      name: 'Quincy Mae',
      logo: 'https://brands.mifasia.com/images/p301.jpg',
      description: '米国デザイナーKelli Murrayによる、シンプルで洗練されたベビー・キッズ服飾ブランド。'
    },
    {
      name: 'Noralee',
      logo: 'https://brands.mifasia.com/images/p121.jpg',
      description: 'Rylee + Cruファミリーの新メンバー。レトロな雰囲気と想像力豊かなデザインが特徴の女の子向けブランド。'
    },
    {
      name: 'Tiny Cottons',
      logo: 'https://brands.mifasia.com/uploads/170972217960652.jpg',
      description: '遊び心とクリエイティビティを大切にする、子どものためのファッションブランド。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-5">
          <div className="flex items-center justify-between">
            <a href="#" className="text-2xl font-bold text-[#7BA591] cursor-pointer">
              楽生株式会社
            </a>
            <div className="hidden md:flex items-center space-x-10">
              <a href="#home" className="text-sm font-medium text-gray-700 hover:text-[#7BA591] transition-colors cursor-pointer">
                ホーム
              </a>
              <a href="#about" className="text-sm font-medium text-gray-700 hover:text-[#7BA591] transition-colors cursor-pointer">
                会社概要
              </a>
              <a href="#services" className="text-sm font-medium text-gray-700 hover:text-[#7BA591] transition-colors cursor-pointer">
                事業内容
              </a>
              <a href="#contact" className="text-sm font-medium text-gray-700 hover:text-[#7BA591] transition-colors cursor-pointer">
                お問い合わせ
              </a>
            </div>
            <button 
              className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700`}></i>
            </button>
          </div>
        </div>
        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4">
            <div className="flex flex-col space-y-4">
              <a href="#home" className="text-sm font-medium text-gray-700 hover:text-[#7BA591] transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>ホーム</a>
              <a href="#about" className="text-sm font-medium text-gray-700 hover:text-[#7BA591] transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>会社概要</a>
              <a href="#services" className="text-sm font-medium text-gray-700 hover:text-[#7BA591] transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>事業内容</a>
              <a href="#contact" className="text-sm font-medium text-gray-700 hover:text-[#7BA591] transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>お問い合わせ</a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img 
            src="https://public.readdy.ai/ai/img_res/88ae3c3c440752599792a74d5301b789.jpg"
            alt="癒しの空間"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/50 to-white/80"></div>
        </div>
        <div className="relative z-10 text-center px-6 w-full max-w-4xl">
          <div className="inline-flex items-center px-5 py-2 bg-[#F5F8F6] rounded-full mb-8">
            <span className="w-2 h-2 bg-[#7BA591] rounded-full mr-2"></span>
            <span className="text-sm text-[#5A7A68]">人・モノ・事業が健やかに循環する</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-gray-800 mb-6 leading-tight">
            持続可能な関係づくりを<br />目指して
          </h1>
          <p className="text-lg text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
            楽生株式会社は、日中間の国際貿易を軸に、<br className="hidden md:block" />
            商品流通・ブランド展開・事業支援を通じて<br className="hidden md:block" />
            中長期的な視点でのビジネス構築を支援しています
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a 
              href="#services"
              className="inline-flex items-center px-8 py-4 bg-[#7BA591] text-white rounded-full hover:bg-[#6A9480] transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-[#7BA591]/20"
            >
              <span className="text-sm font-medium">事業内容を見る</span>
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a 
              href="#contact"
              className="inline-flex items-center px-8 py-4 bg-white text-[#7BA591] rounded-full hover:bg-[#F5F8F6] transition-all duration-300 cursor-pointer whitespace-nowrap border border-[#D4E3DB]"
            >
              <span className="text-sm font-medium">お問い合わせ</span>
            </a>
          </div>
        </div>
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
          <a href="#about" className="w-10 h-10 flex items-center justify-center cursor-pointer">
            <i className="ri-arrow-down-line text-2xl text-[#7BA591]"></i>
          </a>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="order-2 lg:order-1">
              <div className="inline-flex items-center px-5 py-2 bg-[#F5F8F6] rounded-full mb-6">
                <span className="text-sm text-[#5A7A68]">About Us</span>
              </div>
              <h2 className="text-4xl font-bold text-gray-800 mb-6 leading-tight">
                会社概要
              </h2>
              <p className="text-base text-gray-600 leading-relaxed mb-6">
                「楽生」という社名には、事業を単なる取引として捉えるのではなく、人と人、事業と事業の関係性そのものを価値として育てていきたいという考えを込めています。
              </p>
              <p className="text-base text-gray-600 leading-relaxed mb-6">
                短期的な成果を追うのではなく、人・事業・関係性が長く続く形を大切にしたい、その想いから名付けました。
              </p>
              <p className="text-base text-gray-600 leading-relaxed mb-10">
                私たちは、人・モノ・事業が健やかに循環する持続可能な関係づくりを目指しています。
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div className="p-6 bg-[#F5F8F6] rounded-2xl">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#E8F0EC] rounded-xl mb-4">
                    <i className="ri-refresh-line text-2xl text-[#7BA591]"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">循環</h3>
                  <p className="text-sm text-gray-600">健やかに循環する関係性を大切に</p>
                </div>
                <div className="p-6 bg-[#F5F8F6] rounded-2xl">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#E8F0EC] rounded-xl mb-4">
                    <i className="ri-time-line text-2xl text-[#7BA591]"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">持続性</h3>
                  <p className="text-sm text-gray-600">長く続く形を重視したビジネス</p>
                </div>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <div className="relative">
                <div className="w-full h-[500px] rounded-3xl overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20workspace%20with%20elegant%20sage%20green%20plants%20and%20natural%20wood%20desk%2C%20sophisticated%20business%20environment%20with%20laptop%20and%20documents%2C%20clean%20organized%20professional%20setting%2C%20soft%20natural%20lighting%20through%20large%20windows%2C%20premium%20corporate%20aesthetic%2C%20zen-inspired%20workspace%20design%2C%20international%20trade%20business%20atmosphere&width=800&height=1000&seq=rakusei-about-workspace-v1&orientation=portrait"
                    alt="ビジネス環境"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#E8F0EC] rounded-full -z-10"></div>
                <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#F5F8F6] rounded-full -z-10"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-24 px-6 bg-[#FAFBFA]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-5 py-2 bg-white rounded-full mb-6">
              <span className="text-sm text-[#5A7A68]">Our Services</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-800 mb-4">
              事業内容
            </h2>
            <p className="text-base text-gray-600 max-w-3xl mx-auto leading-relaxed">
              日中間の国際貿易を軸に、商品流通・ブランド展開・事業支援を行い、<br className="hidden md:block" />
              中長期的な視点でのビジネス構築を支援しています
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className="bg-white p-8 rounded-3xl hover:shadow-xl hover:shadow-[#7BA591]/10 transition-all duration-300 cursor-pointer group"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-[#F5F8F6] rounded-2xl mb-6 group-hover:bg-[#7BA591] transition-colors duration-300">
                  <i className={`${service.icon} text-3xl text-[#7BA591] group-hover:text-white transition-colors duration-300`}></i>
                </div>
                <div className="mb-3">
                  <span className="text-xs text-[#7BA591] font-medium">{service.subtitle}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3 leading-snug">{service.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-4">{service.description}</p>
                <ul className="space-y-2 mb-6">
                  {service.details.map((detail, idx) => (
                    <li key={idx} className="flex items-start text-xs text-gray-500">
                      <span className="w-1 h-1 bg-[#7BA591] rounded-full mt-1.5 mr-2 flex-shrink-0"></span>
                      <span>{detail}</span>
                    </li>
                  ))}
                </ul>
                <div className="flex items-center text-[#7BA591] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="text-sm font-medium">詳しく見る</span>
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Brand Showcase Section */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-5 py-2 bg-[#F5F8F6] rounded-full mb-6">
              <span className="text-sm text-[#5A7A68]">Our Portfolio</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-800 mb-4">
              ブランド展開実績
            </h2>
            <p className="text-base text-gray-600 max-w-3xl mx-auto leading-relaxed">
              中国市場での展開を支援している主なブランドをご紹介します
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {brands.map((brand, index) => (
              <div 
                key={index}
                className="bg-[#FAFBFA] p-6 rounded-2xl hover:shadow-lg hover:shadow-[#7BA591]/10 transition-all duration-300 cursor-pointer group"
              >
                <div className="w-full h-48 bg-white rounded-xl mb-4 overflow-hidden flex items-center justify-center p-4">
                  <img 
                    src={brand.logo}
                    alt={brand.name}
                    className="w-full h-full object-contain"
                  />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2">{brand.name}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{brand.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div>
              <div className="inline-flex items-center px-5 py-2 bg-[#F5F8F6] rounded-full mb-6">
                <span className="text-sm text-[#5A7A68]">Contact Us</span>
              </div>
              <h2 className="text-4xl font-bold text-gray-800 mb-6">
                お問い合わせ
              </h2>
              <p className="text-base text-gray-600 leading-relaxed mb-10">
                ご質問やご相談がございましたら、お気軽にお問い合わせください。担当者より折り返しご連絡いたします。
              </p>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#F5F8F6] rounded-xl flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-[#7BA591]"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-gray-800 mb-1">所在地</h3>
                    <p className="text-sm text-gray-600">東京都足立区足立二丁目20番12号 エールシャブル302</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#F5F8F6] rounded-xl flex-shrink-0">
                    <i className="ri-mail-line text-xl text-[#7BA591]"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-gray-800 mb-1">メール</h3>
                    <p className="text-sm text-gray-600">info@rakuseiglobal.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#F5F8F6] rounded-xl flex-shrink-0">
                    <i className="ri-phone-line text-xl text-[#7BA591]"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-gray-800 mb-1">電話</h3>
                    <p className="text-sm text-gray-600">07014553736</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-[#F5F8F6] p-8 rounded-3xl">
              <form 
                id="contact_form"
                data-readdy-form
                action="https://readdy.ai/api/form/d64jd95anburc340qug0"
                method="POST"
                className="space-y-6"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  const data = new URLSearchParams();
                  
                  formData.forEach((value, key) => {
                    data.append(key, value.toString());
                  });

                  fetch(form.action, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: data.toString()
                  })
                  .then(response => {
                    if (response.ok) {
                      alert('お問い合わせありがとうございます。担当者より折り返しご連絡いたします。');
                      form.reset();
                    } else {
                      alert('送信に失敗しました。もう一度お試しください。');
                    }
                  })
                  .catch(() => {
                    alert('送信に失敗しました。もう一度お試しください。');
                  });
                }}
              >
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    お名前 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl focus:border-[#7BA591] focus:ring-2 focus:ring-[#7BA591]/20 outline-none transition-all text-sm"
                    placeholder="山田太郎"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    メールアドレス <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl focus:border-[#7BA591] focus:ring-2 focus:ring-[#7BA591]/20 outline-none transition-all text-sm"
                    placeholder="example@email.com"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    会社名
                  </label>
                  <input
                    type="text"
                    name="company"
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl focus:border-[#7BA591] focus:ring-2 focus:ring-[#7BA591]/20 outline-none transition-all text-sm"
                    placeholder="株式会社〇〇"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    お問い合わせ内容 <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    name="message"
                    required
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl focus:border-[#7BA591] focus:ring-2 focus:ring-[#7BA591]/20 outline-none transition-all resize-none text-sm"
                    placeholder="お問い合わせ内容をご記入ください（500文字以内）"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="w-full px-8 py-4 bg-[#7BA591] text-white rounded-xl hover:bg-[#6A9480] transition-all duration-300 cursor-pointer whitespace-nowrap text-sm font-medium shadow-lg shadow-[#7BA591]/20"
                >
                  送信する
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-16 px-6 bg-[#5A7A68]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div className="md:col-span-2">
              <h3 className="text-2xl font-bold text-white mb-4">
                楽生株式会社
              </h3>
              <p className="text-sm text-[#D4E3DB] leading-relaxed mb-6">
                人・モノ・事業が健やかに循環する持続可能な関係づくりを目指し、日中間の国際貿易を軸に、商品流通・ブランド展開・事業支援を行っています。
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="w-10 h-10 flex items-center justify-center bg-[#6A9480] rounded-full hover:bg-[#7BA591] transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-lg text-white"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center bg-[#6A9480] rounded-full hover:bg-[#7BA591] transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill text-lg text-white"></i>
                </a>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-bold text-white mb-4">リンク</h4>
              <ul className="space-y-3">
                <li><a href="#home" className="text-sm text-[#D4E3DB] hover:text-white transition-colors cursor-pointer">ホーム</a></li>
                <li><a href="#about" className="text-sm text-[#D4E3DB] hover:text-white transition-colors cursor-pointer">会社概要</a></li>
                <li><a href="#services" className="text-sm text-[#D4E3DB] hover:text-white transition-colors cursor-pointer">事業内容</a></li>
                <li><a href="#contact" className="text-sm text-[#D4E3DB] hover:text-white transition-colors cursor-pointer">お問い合わせ</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-bold text-white mb-4">お問い合わせ</h4>
              <ul className="space-y-3 text-sm text-[#D4E3DB]">
                <li>東京都足立区足立二丁目20番12号 エールシャブル302</li>
                <li>TEL: 07014553736</li>
                <li>info@rakuseiglobal.com</li>
              </ul>
            </div>
          </div>
          <div className="pt-8 border-t border-[#6A9480] text-center">
            <p className="text-xs text-[#D4E3DB]">
              © 2025 楽生株式会社. All rights reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
